/**
 * @file: useReportHeaderMetrics.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useSystemMetrics } from '@euler/functions/useSystemMetrics';

const kHeaderMaxExtend = 300;
const kImageInitialScale = 2;
const kVehicleInfoHeight = 90;
const kVehicleInfoMarginTop = 8;
const kVehicleImageWidth = 90;
const kVehicleImageHeight = 60;
const kOffset = 0;

export const useReportHeaderMetrics = () => {
  const { rpx } = useResponsiveContext();
  const {
    navBarHeight,
    statusBarHeight,
    safeAreaFrame,
    isTablet,
    safeAreaInsets,
  } = useSystemMetrics();
  const headerHeight =
    navBarHeight + rpx(kVehicleInfoHeight + kVehicleInfoMarginTop + kOffset);
  const headerMaxExtend = rpx(kHeaderMaxExtend);
  return {
    isTablet,
    safeAreaInsets,
    safeAreaFrame,
    navBarHeight,
    statusBarHeight,
    headerMaxExtend,
    headerHeight,
    offset: rpx(kOffset),
    vehicleInfoHeight: rpx(kVehicleInfoHeight),
    vehicleImageHeight: rpx(kVehicleImageHeight),
    vehicleImageWidth: rpx(kVehicleImageWidth),
    initialImageScale: kImageInitialScale,
  };
};
